import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default {
  path: '/',
  redirect: 'reconversao-manual',
  component: LayoutPadrao,
  children: [
    {
      path: '/reconversao-manual',
      name: 'reconversao-manual',
      component: () => import('./pages/ListarReconversaoManual.vue')
    }
  ]
}
